import { PHONE_CALLS_ROUTE, pageKindLineText, t } from '@bms2/shared';
import { PageModule } from '../../shell/PageModule';
import { CALL_COLUMNS, CallList } from './CallList';

export { PHONE_CALLS_ROUTE };

/**
 * 🔒 Calls, the phone system's Recents (decision 11860; the owner's P5a): every call the viewer reads under decision
 * 11782, inbound, outbound, missed and voicemail, newest first, in the List Viewer.
 */
export function CallsPage({ apiBaseUrl = '' }: { apiBaseUrl?: string }) {
  return (
    <PageModule title={t('phonePages.calls.title')} subtitle={pageKindLineText({ page: 'named', route: PHONE_CALLS_ROUTE })} icon="phoneCalls">
      <CallList list="calls" apiBaseUrl={apiBaseUrl} columns={CALL_COLUMNS} recordType={t('phonePages.calls.title')} emptyAction={t('phonePages.calls.empty')} />
    </PageModule>
  );
}
